var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuildingWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37866 5.22949H9.04491V6.76883H5.37866V5.22949Z",
    fill: "#00BCDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37866 8.72998H9.04491V10.2693H5.37866V8.72998Z",
    fill: "#00BCDA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37866 12.23H9.04491V13.7693H5.37866V12.23Z",
    fill: "#00BCDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37866 15.7305H9.04491V17.2698H5.37866V15.7305Z",
    fill: "#00BCDA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7928 19.3197V6.74193L20.8308 6.73255V15.2176H22.3692V5.96198C22.3692 5.54208 22.0184 5.19229 21.5991 5.19229L12.0227 5.20347C11.5982 5.20398 11.2544 5.54839 11.2544 5.97316V19.3197H3.16923V4.08916L11.2544 1.91414V3.66157H12.7928V0.910187C12.7928 0.412238 12.3051 0.0374691 11.8238 0.166905L2.20025 2.75578C1.86431 2.84619 1.63077 3.15096 1.63077 3.49906V19.3197H0V20.8591H24V19.3197H12.7928Z",
    fill: "#00BCDA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8307 16.603H22.3692V18.0369H20.8307V16.603Z",
    fill: "#00BCDA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.955 8.72998H18.6213V10.2693H14.955V8.72998Z",
    fill: "#00BCDA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.955 12.2305H18.6213V13.7698H14.955V12.2305Z",
    fill: "#00BCDA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.955 15.7305H18.6213V17.2698H14.955V15.7305Z",
    fill: "#00BCDA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuildingWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/building-white.8f8fbeedcb53357cff87860a0f1d1fac.svg";